import { useEffect } from 'react';
import { useActivateBonusViaLink, useApiContext } from 'react-easyrocket';
import { Navigate, useParams } from 'react-router';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { useRoute } from 'src/router/hooks/useRoute.ts';

export function ActivateBonus() {
  const { bonusId } = useParams();
  const { isAuthenticated } = useApiContext();
  const { mutateAsync } = useActivateBonusViaLink();
  const { startRegistration } = useAuthFlow();
  const { ROUTE } = useRoute();

  useEffect(() => {
    if (bonusId) {
      const activateBonusByLink = () => mutateAsync({ bonus_id: bonusId });

      if (isAuthenticated) {
        activateBonusByLink();
      } else {
        startRegistration({ onSuccess: activateBonusByLink, defaultFlow: false });
      }
    }
  }, []);

  return <Navigate to={ROUTE.MAIN.get()} />;
}
